const { APIURL, PURPLECOWURL, REPOURL, SIEMURL, ADMINURL, COOKIELANG } = window.GlobalPathMap || {
  APIURL: "",
  PURPLECOWURL: "",
  REPOURL: "",
  SIEMURL: "",
  ADMINURL: "",
};

export default {
  PURPLECOWURL,
  CDNURL: PURPLECOWURL + "/web/assets/images",
  APIURL,
  REPOURL,
  SIEMURL,
  ADMINURL,
  QUBITCORPURL: "https://w.qubitsec.com/" + COOKIELANG,
  QUBITPRIVACY: "https://w.plura.io/index.html?doc=/policy/" + COOKIELANG + "/privacy.md",
  QUBITTOS: "https://w.plura.io/index.html?doc=/policy/" + COOKIELANG + "/terms.md",
  PLURAIO: "plura.io",
};
